import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { Reveal } from '../components/Reveal';
import { approach } from '../data/content';

export const Approach = () => (
  <section data-testid="approach-section" className="bg-cream">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <SectionHeading
        chapter="05"
        eyebrow="Our Approach"
        title="From Business Challenge to Digital Opportunity."
        copy="A clear, practical process that keeps your goals at the center of everything we build."
      />
      <div className="relative mt-16">
        <div
          className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-forest/10 via-forest/50 to-forest/10 lg:block"
          aria-hidden="true"
        />
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {approach.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.12}>
              <div data-testid={`approach-step-${s.num}`} className="group relative">
                <span className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full border-2 border-forest bg-forest font-mono text-sm font-semibold text-goldlight shadow-[0_10px_30px_-12px_rgba(6,75,43,0.3)] transition-all duration-500 group-hover:bg-moss">
                  {s.num}
                </span>
                <h3 className="mt-6 font-display text-2xl font-bold text-ink">{s.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-ink">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal delay={0.25}>
        <Link to="/contact" data-testid="approach-cta" className="btn-forest mt-14">
          Start Your Project <ArrowUpRight size={16} />
        </Link>
      </Reveal>
    </div>
  </section>
);
